$(function () {
  var $menuTrigger = $('.menu_trigger');
  var $menuTrigger2 = $('.menu_trigger2');
  var $closeTrigger = $('.menu_overlay .close_trigger');
  var $menuOverlay = $('.menu_overlay');

  $(document).keyup(e => {
    if ($('body').hasClass('menuOpen')) {
      if (e.keyCode === 27) {
        e.preventDefault();
        e.stopPropagation();
        $menuOverlay.animate({ scrollTop: 0 }, 1);
        $('body').removeClass('menuOpen');
        $menuOverlay.fadeOut("slow");
        $menuOverlay.off('click', removeMenu);
      }
    }
  })

  $menuTrigger.on('click', function (e) {
    e.preventDefault();
    $('body').addClass('menuOpen');
    $menuOverlay.fadeIn("slow", function (e) {
      $menuOverlay.on('click', removeMenu);
    })
    $('.menu_overlay_content a')[0].focus();
  });

  $menuTrigger2.on('click', function (e) {
    e.preventDefault();
    $('body').addClass('menuOpen');
    $menuOverlay.fadeIn("slow", function (e) {
      $menuOverlay.on('click', removeMenu);
    })
  });
  $closeTrigger.on('click', function (e) {
    e.preventDefault();
    e.stopPropagation();
    $menuOverlay.animate({ scrollTop: 0 }, 1);
    $('body').removeClass('menuOpen');
    $menuOverlay.fadeOut("slow");
    $menuOverlay.off('click', removeMenu);
  });
  function removeMenu(e) {
    if (!$(e.target).is('.menu_overlay_inner div[class^="col"] *')) {
      $('body').removeClass('menuOpen');
      $menuOverlay.fadeOut("slow");
      $menuOverlay.off('click', removeMenu);
    }
  }
});